import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';

import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import { EquipmentList } from '~/src/features/full-buy/containers/EquipmentList';
import { MainLayout } from '~/src/features/full-buy/containers/MainLayout/MainLayout';
import skipPrivateSectorEquipmentStep from '~/src/features/full-buy/store/actions/skipPrivateSectorEquipment';

const PrivateSectorEquipments = (): JSX.Element => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(skipPrivateSectorEquipmentStep());
    }, []);

    return (
        <MainLayout>
            <TextWrapper $lastIndent={false}>
                <H3>Необходимо выбрать оборудование</H3>
                <Paragraph4>
                    Без него услуги не&nbsp;будут работать, и&nbsp;мы&nbsp;не&nbsp;сможем вам их&nbsp;подключить.
                </Paragraph4>
            </TextWrapper>

            <EquipmentList category={EShopCategory.PrivateSectorEquipment}/>
        </MainLayout>
    );
};

export default PrivateSectorEquipments;
